import { Field } from "./Field";
import { BRAND_GROWTH_FIELDS } from "@/lib/labels";

const HINTS = {
  currentAudience: "Size, demographics, how they found you",
  strongestPlatforms: "e.g. TikTok and Instagram Reels",
  targetAudience: "Who do you want listening? Age, scenes, cities",
  brandIdentity: "Your sound, look, and story in your own words",
  upcomingReleases: "Singles, EPs, albums, tours, visuals",
  dreamCollabs: "Artists, producers, songwriters",
  dreamBrands: "Fashion, tech, lifestyle — anyone",
  growthMarkets: "e.g. Atlanta, London, Lagos, Tokyo",
  successVision: "Be specific — numbers, stages, deals",
};

export const StepBrandGrowth = ({ form, update }) => (
  <div>
    <p className="text-sm text-slate-400 mb-6">
      Before the paperwork — tell us where you're headed. This shapes how Xyion builds your rollout, partnerships,
      and growth plan.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {BRAND_GROWTH_FIELDS.map(([key, label, multiline]) => (
        <Field
          key={key}
          label={label}
          testid={`input-brand-${key}`}
          multiline={multiline}
          className={multiline ? "md:col-span-2" : ""}
          placeholder=""
          hint={HINTS[key]}
          value={form.brandGrowth[key]}
          onChange={(e) => update(`brandGrowth.${key}`, e.target.value)}
        />
      ))}
    </div>
  </div>
);
